import React, { useEffect, useState } from 'react';
import { DEFAULT_CONSULTANT_MODE, getProductBrandForMode } from '../constants';

export default function Logo({ modeId = DEFAULT_CONSULTANT_MODE }) {
  const brand = getProductBrandForMode(modeId);
  const [logoSrc, setLogoSrc] = useState(brand.logo);
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    setLogoSrc(brand.logo);
    setHasError(false);
  }, [brand.logo]);

  const logoFormats = [
    brand.logo,
    brand.logo.replace('.png', '.svg'),
    '/branding/wraith-logo.svg',
    '/branding/apex-elicit-logo.svg',
  ];

  const handleError = () => {
    const currentIndex = logoFormats.indexOf(logoSrc);
    if (currentIndex < logoFormats.length - 1) {
      setLogoSrc(logoFormats[currentIndex + 1]);
    } else {
      setHasError(true);
    }
  };

  if (hasError) {
    return (
      <div>
        <h1 className="text-xl font-bold tracking-tight text-teal-400">{brand.productName}</h1>
        <p className="text-[10px] text-gray-500 uppercase tracking-wide">{brand.tagline}</p>
      </div>
    );
  }

  return (
    <div className="flex flex-col">
      <img
        src={logoSrc}
        alt={brand.productName}
        className="h-9 object-contain object-left"
        onError={handleError}
      />
    </div>
  );
}
